import React, { useState } from "react";
import { Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

const HCissues = () => {
  const [selectedOption, setSelectedOption] = useState("none");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="MajorConcernsContainer">
      {/* Dropdpwn for Community Engagement Issues */}
      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column", // Mobile: stack
              sm: "row", // Tablet/Desktop: inline
            },
            alignItems: {
              xs: "flex-start",
              sm: "center",
            },
            gap: 2, // adds spacing between text and dropdown
          }}
        >
          <Typography className="issues-area-helper">Key Issues In</Typography>

          <FormControl
            sx={{
              width: {
                xs: "100%",
                sm: 300,
              },
            }}
            className="AreaFormControl"
          >
            <Select
              labelId="Area-label"
              id="Area"
              value={selectedOption}
              onChange={handleChange}
              displayEmpty
              className="IssueAreaSelect"
            >
              <MenuItem value="none">
                <em>-- Select an area --</em>
              </MenuItem>
              <MenuItem value="Evinston">Evinston</MenuItem>
              <MenuItem value="Gordon">Gordon</MenuItem>
              <MenuItem value="Hawthorne">Hawthorne</MenuItem>
              <MenuItem value="IslandGrove">Island Grove</MenuItem>
              <MenuItem value="Melrose">Melrose</MenuItem>
              <MenuItem value="Micanopy">Micanopy</MenuItem>
              <MenuItem value="Monteocha">Monteocha</MenuItem>
              <MenuItem value="OrangeHeights">Orange Heights</MenuItem>
              <MenuItem value="Rochelle">Rochelle</MenuItem>
              <MenuItem value="Waldo">Waldo</MenuItem>{" "}
            </Select>
          </FormControl>
        </Box>
      </Box>
      {/* Concerns for selected are to be displayed */}
      <div className="MajorConcernsData">
        {selectedOption === "none" && (
          <Typography variant="body2">
            <p className="ZeroBottomMargin">
              Please select an area from the above dropdown to view healthcare
              concers related to it.
            </p>
          </Typography>
        )}{" "}
        {selectedOption === "OrangeHeights" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Evinston" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Gordon" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Hawthorne" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Improve the structure and services of animal care facilities
              </li>
              <li>
                Establish a local health clinic for better access to medical
                care
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "IslandGrove" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>There is a need to address food insecurity</li>
              <li>
                Concerns about confusing septic tank notices from the county
              </li>
              <li>The volunteer fire department lacks funding and equipment</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Melrose" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Melrose is a medical "dead zone" with limited access to
                healthcare
              </li>
              <li>Need for improved community health literacy</li>
              <li>Lack of locations to access fresh food</li>
              <li>Health disparities affecting the community</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Micanopy" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Address food insecurity in Micanopy, where two food banks serve
                over 200 people each week
              </li>
              <li>
                Medical support is needed in Micanopy following the loss of the
                UF Health bus service
              </li>
              <li>
                Urgent medical care and emergency room service is not accessible{" "}
              </li>
              <li>
                Some Micanopy residents do not have access to health insurance{" "}
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Monteocha" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Rochelle" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>More law enforcement is needed in the Rochelle area</li>
              <li>
                In the event of future storms, more County support with
                hurricane clean ups is needed
              </li>
              <li>Rochelle is a food desert </li>
              <li>
                No fire service in this area, which causes homeowners insurance
                to be high
              </li>
              <li>Need for fire hydrants</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Waldo" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Repurpose the old community center as a medical facility</li>
              <li>
                Lack of healthcare facilities: no pharmacy or medical facility
                in the area
              </li>
              <li>
                Open an express store (like an express Publix) for access to
                pharmacy services and fresh groceries
              </li>
              <li>
                Establish a Shands Satellite location or Azalea Health clinic
              </li>
              <li>Lack of grocery stores and access to fresh food</li>
              <li>People's mistrust of the Shands Health bus service</li>
              <li>No local doctors available in Waldo</li>
              <li>No assisted living facilities in the area</li>
              <li>
                Recruit people with medical backgrounds as volunteers to serve
                the community
              </li>
            </ul>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default HCissues;
